import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { formatCurrency } from "../utils/format";

const BarTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;

  const item = payload[0].payload;

  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-md px-3 py-2 text-sm">
      <p className="text-xs text-slate-500 font-medium">{item.name}</p>
      <p className="text-slate-900 font-semibold mt-0.5 tabular-nums">{formatCurrency(item.cost)}</p>
    </div>
  );
};

const AccountBarBreakdown = ({ data, color }) => {
  if (!data.length) {
    return <p className="text-slate-400 text-sm py-8 text-center">No accounts in this category for the selected range.</p>;
  }

  return (
    <div style={{ height: Math.max(160, data.length * 44) }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 24, left: 0, bottom: 4 }}>
          <CartesianGrid horizontal={false} stroke="#e2e8f0" />
          <XAxis
            type="number"
            tickFormatter={(v) => `$${Math.round(v).toLocaleString()}`}
            tick={{ fill: "#94a3b8", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            type="category"
            dataKey="name"
            width={170}
            tick={{ fill: "#334155", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<BarTooltip />} cursor={{ fill: "#f1f5f9" }} />
          <Bar dataKey="cost" fill={color} radius={[0, 4, 4, 0]} barSize={18} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AccountBarBreakdown;
